var map = {
	"./DATALIFE-LOGO-INFO.png": 579,
	"./DATALIFE-LOGO-INFO@2x.png": 580,
	"./DLF - Flat Logo Azul Escuro.svg": 581,
	"./DLF - Flat Logo Azul e Branco.svg": 582,
	"./DLF - Flat Logo Branco.svg": 583,
	"./DLF - Gradiente Logo Azul Escuro.svg": 584,
	"./DLF - Gradiente Logo Azul e Branco.svg": 585,
	"./DLF - Gradiente Logo Branco.svg": 586,
	"./MPA-completa.png": 587,
	"./MPA-completa_2.png": 113,
	"./MPA-simbolo.png": 588,
	"./datalife-idble-logo.png": 589,
	"./datalife-idble-logo.svg": 212,
	"./datalife-provisorio.png": 590,
	"./enablers.svg": 202,
	"./favicon-16x16.png": 591,
	"./favicon-32x32.png": 592,
	"./favicon-96x96.png": 593,
	"./khomp.svg": 136,
	"./logo-khomp.png": 203,
	"./logo.svg": 594,
	"./logomarca.png": 595,
	"./sygnet.svg": 596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 201;